import { Box, Card, Button } from "@mui/material";
import { useStoreContext } from "..";
import { useState } from "react";
import InfoModal from "../components/InfoModal";

const Login = () => {
  const { keycloakStore } = useStoreContext();
  const [showInfo, setShowInfo] = useState<boolean>(false);

  return (
    <Box className="login-page">
      <Card className="login-page-container" elevation={10}>
        <Button
          className="button-shadow"
          onClick={() => keycloakStore.login(null)}
        >
          LOGGA IN
        </Button>
        <Button
          className="secondary-button button-shadow"
          sx={{ marginTop: 2 }}
          onClick={() => setShowInfo(true)}
        >
          HJÄLP
        </Button>
      </Card>
      {showInfo && <InfoModal open={true} onClose={() => setShowInfo(false)} />}
    </Box>
  );
};

export default Login;
